import TopNav from "../components/Navbars/TopNav";
import VerificationDetailsViewer from "../components/viewers/VerificationDetailsViewer";
import { Link, useLocation, useParams, useNavigate } from "react-router-dom";
import { ChevronRight, Home, ArrowLeft } from "lucide-react";
import Footer from "../components/Navbars/footer";

function ProspectiveDashboard() {
  const location = useLocation();
  const navigate = useNavigate();
  const { pathname } = location;
  const [, , type] = pathname.split("/");
  const { application_id } = useParams();

  const getPageTitle = (t) => {
    const map = {
      it: "IT Verification",
      siwes: "SIWES Verification",
      gap: "NDE Verification",
    };
    return map[t] || "Verification Details";
  };

  return (
    <div className="flex flex-col w-full flex-1">
      <TopNav />
      <div className="container max-w-[1200px]">
        <div className="main gap-4">
          <div className="flex items-center justify-between w-full mb-2">
            <div className="flex items-center gap-2 text-sm text-gray-500">
              <Link
                to="/dashboard"
                className="flex items-center hover:text-green-600 transition-colors"
              >
                <Home size={16} />
              </Link>
              <ChevronRight size={16} className="text-gray-300" />
              <Link
                to="/allapp"
                className="hover:text-green-600 transition-colors"
              >
                Verifications
              </Link>
              <ChevronRight size={16} className="text-gray-300" />
              <span className="font-semibold text-gray-900">
                {getPageTitle(type)}
              </span>
            </div>

            <button
              onClick={() => navigate(-1)}
              className="flex items-center gap-1 text-sm font-medium text-gray-500 hover:text-gray-900 transition-colors"
            >
              <ArrowLeft size={16} /> Back
            </button>
          </div>

          <VerificationDetailsViewer
            applicationId={application_id}
            internshipType={type}
          />
        </div>
      </div>
      <Footer />
    </div>
  );
}

export default ProspectiveDashboard;
